function SupportFooter() {
  return (
    <footer className="landstar-support-footer">
      Questions? Contact us at{" "}
      <a href="mailto:landstar@stran.com">landstar@stran.com</a>.
    </footer>
  );
}

export default SupportFooter;
